var _defs, _g, _defs2, _g2, _defs3, _g3, _defs4, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 626.2 292",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 9.1,
    width: 177.5,
    height: 431.8,
    viewBox: "44.8 78.8 177.5 431.8",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tm-fa1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2B45F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tm-fu1",
    gradientUnits: "userSpaceOnUse",
    x1: 40,
    y1: 120,
    x2: 260,
    y2: 420
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2B45F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6A8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tm-fh1",
    cx: 0.3,
    cy: 0.22,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tm-fc1"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 54
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) rotate(0,150,338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.0 338.0 L129.4 417.8 L124.0 495.6",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 493.6,
    width: 32,
    height: 13,
    rx: 6.5,
    fill: "#0D1633",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.0 338.0 L170.6 417.8 L176.0 495.6",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 493.6,
    width: 32,
    height: 13,
    rx: 6.5,
    fill: "#0D1633",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.0 196 L150.0 216",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.0 236.0 L64.7 199.1 L60.8 143.2",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.8,
    cy: 143.2,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.8,
    cy: 143.2,
    r: 12,
    fill: "url(#tm-fu1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.8,
    cy: 143.2,
    r: 12,
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.9,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L184.0 334 Q182.0 350 169.0 350 L131.0 350 Q118.0 350 116.0 334 Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L184.0 334 Q182.0 350 169.0 350 L131.0 350 Q118.0 350 116.0 334 Z",
    fill: "url(#tm-fa1)",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L184.0 334 Q182.0 350 169.0 350 L131.0 350 Q118.0 350 116.0 334 Z",
    fill: "url(#tm-fh1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L184.0 334 Q182.0 350 169.0 350 L131.0 350 Q118.0 350 116.0 334 Z",
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.0 216 Q150.0 240 168.0 216.0",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.0 232 V252",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.0 232 V252",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.0 236.0 L200.5 294.7 L206.3 350.4",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.3,
    cy: 350.4,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.3,
    cy: 350.4,
    r: 12,
    fill: "url(#tm-fu1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.3,
    cy: 350.4,
    r: 12,
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.9,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150,146) rotate(-5)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "url(#tm-fa1)",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "url(#tm-fh1)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tm-fc1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.173913043478261) translate(-110,-100)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 96 A46 46 0 0 1 156 96 Q134 70 110 78 Q84 70 64 96Z",
    fill: "#0D1633",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110,-1.5) scale(1,1) translate(-110,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 88 Q94 82 104 87 M118 87 Q128 82 138 88",
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.7,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 106 Q94 98 101 106 M119 106 Q126 98 133 106",
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.95,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 119 Q110 140 125 119Z",
    fill: "#fff",
    fillOpacity: 0.95,
    stroke: "#fff",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.9,
    strokeWidth: 3
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 173.5,
    y: 0,
    width: 146.6,
    height: 440.9,
    viewBox: "75.4 69.7 146.6 440.9",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tm-fa2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7A5CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27DB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tm-fu2",
    gradientUnits: "userSpaceOnUse",
    x1: 40,
    y1: 120,
    x2: 260,
    y2: 420
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7A5CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27DB8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tm-fh2",
    cx: 0.3,
    cy: 0.22,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tm-fc2"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 54
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) rotate(0,150,338)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.0,146) rotate(4) scale(1.173913043478261) translate(-110,-100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 190 V96 A54 54 0 0 1 164 96 V190 Q150 176 150 150 V100 Q110 66 70 100 V150 Q70 176 56 190Z",
    fill: "#7A5CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 190 V96 A54 54 0 0 1 164 96 V190 Q150 176 150 150 V100 Q110 66 70 100 V150 Q70 176 56 190Z",
    fill: "#0D1633",
    opacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.0 338.0 L129.4 417.8 L124.0 495.6",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 493.6,
    width: 32,
    height: 13,
    rx: 6.5,
    fill: "#0D1633",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.0 338.0 L170.6 417.8 L176.0 495.6",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 493.6,
    width: 32,
    height: 13,
    rx: 6.5,
    fill: "#0D1633",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.0 196 L150.0 216",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.0 236.0 L101.6 295.1 L97.7 351.0",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.7,
    cy: 351,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.7,
    cy: 351,
    r: 12,
    fill: "url(#tm-fu2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.7,
    cy: 351,
    r: 12,
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.9,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L201.0 372 Q199.0 388 186.0 388 L114.0 388 Q101.0 388 99.0 372 Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L201.0 372 Q199.0 388 186.0 388 L114.0 388 Q101.0 388 99.0 372 Z",
    fill: "url(#tm-fa2)",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L201.0 372 Q199.0 388 186.0 388 L114.0 388 Q101.0 388 99.0 372 Z",
    fill: "url(#tm-fh2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L201.0 372 Q199.0 388 186.0 388 L114.0 388 Q101.0 388 99.0 372 Z",
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.0 216 Q150.0 250 170.0 216.0",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 240,
    r: 5.5,
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.0 236.0 L198.4 295.1 L202.3 351.0",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.3,
    cy: 351,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.3,
    cy: 351,
    r: 12,
    fill: "url(#tm-fu2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.3,
    cy: 351,
    r: 12,
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.9,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150,146) rotate(4)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "url(#tm-fa2)",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "url(#tm-fh2)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tm-fc2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.173913043478261) translate(-110,-100)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 190 V96 A54 54 0 0 1 164 96 V190 Q150 176 150 150 V100 Q110 66 70 100 V150 Q70 176 56 190Z",
    fill: "#0D1633",
    opacity: 0.42
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110,1.2) scale(1,1) translate(-110,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 88 Q94 82 104 87 M118 87 Q128 82 138 88",
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.7,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 106 Q94 98 101 106 M119 106 Q126 98 133 106",
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.95,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 119 Q110 140 125 119Z",
    fill: "#fff",
    fillOpacity: 0.95,
    stroke: "#fff",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.9,
    strokeWidth: 3
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 316.1,
    y: 10.9,
    width: 136.6,
    height: 430,
    viewBox: "81.7 80.6 136.6 430",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tm-fa3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00A884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EE6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tm-fu3",
    gradientUnits: "userSpaceOnUse",
    x1: 40,
    y1: 120,
    x2: 260,
    y2: 420
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00A884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EE6C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tm-fh3",
    cx: 0.3,
    cy: 0.22,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tm-fc3"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 54
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) rotate(0,150,338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.0 338.0 L129.4 417.8 L124.0 495.6",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 493.6,
    width: 32,
    height: 13,
    rx: 6.5,
    fill: "#0D1633",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.0 338.0 L170.6 417.8 L176.0 495.6",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 493.6,
    width: 32,
    height: 13,
    rx: 6.5,
    fill: "#0D1633",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.0 196 L150.0 216",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.0 236.0 L101.6 295.1 L97.7 351.0",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.7,
    cy: 351,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.7,
    cy: 351,
    r: 12,
    fill: "url(#tm-fu3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.7,
    cy: 351,
    r: 12,
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.9,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L189.0 378 Q187.0 394 174.0 394 L126.0 394 Q113.0 394 111.0 378 Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L189.0 378 Q187.0 394 174.0 394 L126.0 394 Q113.0 394 111.0 378 Z",
    fill: "url(#tm-fa3)",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L189.0 378 Q187.0 394 174.0 394 L126.0 394 Q113.0 394 111.0 378 Z",
    fill: "url(#tm-fh3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L189.0 378 Q187.0 394 174.0 394 L126.0 394 Q113.0 394 111.0 378 Z",
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.0 216 L150.0 264 L172.0 216.0",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.0 264 V389",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 304,
    width: 22,
    height: 6,
    rx: 3,
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.0 236.0 L198.4 295.1 L202.3 351.0",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.3,
    cy: 351,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.3,
    cy: 351,
    r: 12,
    fill: "url(#tm-fu3)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.3,
    cy: 351,
    r: 12,
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.9,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150,146) rotate(-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "url(#tm-fa3)",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "url(#tm-fh3)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tm-fc3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.173913043478261) translate(-110,-100)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 96 A46 46 0 0 1 156 96 Q134 70 110 78 Q84 70 64 96Z",
    fill: "#0D1633",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110,-0.8999999999999999) scale(1,1) translate(-110,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 88 Q94 82 104 87 M118 87 Q128 82 138 88",
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.7,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 106 Q94 98 101 106 M119 106 Q126 98 133 106",
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.95,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 97,
    width: 24,
    height: 17,
    rx: 5,
    fill: "#fff",
    fillOpacity: 0.22,
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 97,
    width: 24,
    height: 17,
    rx: 5,
    fill: "#fff",
    fillOpacity: 0.22,
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 104h8",
    stroke: "#fff",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 119 Q110 140 125 119Z",
    fill: "#fff",
    fillOpacity: 0.95,
    stroke: "#fff",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.9,
    strokeWidth: 3
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 448.7,
    y: 13.8,
    width: 177.5,
    height: 427.1,
    viewBox: "77.7 83.5 177.5 427.1",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tm-fa4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0E1648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B5BF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tm-fu4",
    gradientUnits: "userSpaceOnUse",
    x1: 40,
    y1: 120,
    x2: 260,
    y2: 420
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0E1648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B5BF0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tm-fh4",
    cx: 0.3,
    cy: 0.22,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fff",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tm-fc4"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 54
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) rotate(0,150,338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.0 338.0 L129.4 417.8 L124.0 495.6",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 493.6,
    width: 32,
    height: 13,
    rx: 6.5,
    fill: "#0D1633",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.0 338.0 L170.6 417.8 L176.0 495.6",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 493.6,
    width: 32,
    height: 13,
    rx: 6.5,
    fill: "#0D1633",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.0 196 L150.0 216",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.0 236.0 L99.5 294.7 L93.7 350.4",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.7,
    cy: 350.4,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.7,
    cy: 350.4,
    r: 12,
    fill: "url(#tm-fu4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.7,
    cy: 350.4,
    r: 12,
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.9,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L184.0 334 Q182.0 350 169.0 350 L131.0 350 Q118.0 350 116.0 334 Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L184.0 334 Q182.0 350 169.0 350 L131.0 350 Q118.0 350 116.0 334 Z",
    fill: "url(#tm-fa4)",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L184.0 334 Q182.0 350 169.0 350 L131.0 350 Q118.0 350 116.0 334 Z",
    fill: "url(#tm-fh4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.0 250 Q104.0 212 150 212 Q196.0 212 196.0 250 L184.0 334 Q182.0 350 169.0 350 L131.0 350 Q118.0 350 116.0 334 Z",
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.85,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.0 214 L150.0 230 L172.0 214.0",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.0 228 L157.0 228 L154.0 240 L160.0 296 L150.0 310 L140.0 296 L146.0 240Z",
    fill: "#fff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.0 236.0 L235.3 199.1 L239.2 143.2",
    fill: "none",
    stroke: "#0D1633",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.2,
    cy: 143.2,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.2,
    cy: 143.2,
    r: 12,
    fill: "url(#tm-fu4)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.2,
    cy: 143.2,
    r: 12,
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.9,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150,146) rotate(5)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "url(#tm-fa4)",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "url(#tm-fh4)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tm-fc4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.173913043478261) translate(-110,-100)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 90 A46 46 0 0 1 154 90 Q110 60 66 90Z",
    fill: "#0D1633",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(110,1.5) scale(1,1) translate(-110,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84 88 Q94 82 104 87 M118 87 Q128 82 138 88",
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.7,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 106 Q94 98 101 106 M119 106 Q126 98 133 106",
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.95,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 119 Q110 140 125 119Z",
    fill: "#fff",
    fillOpacity: 0.95,
    stroke: "#fff",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("circle", {
    r: 54,
    fill: "none",
    stroke: "#fff",
    strokeOpacity: 0.9,
    strokeWidth: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.642d6378cd71c1d9e89712afc4a88a19.svg";
export { ForwardRef as ReactComponent };